import {
  SET_PATIENT,
  SET_PATIENTS,
  REMOVE_PATIENT,
  RESET_PATIENTS,
  APPEND_PATIENTS,
  START_SYNCING_PATIENT,
  STOP_SYNCING_PATIENT,
} from '../actions/patients-actions.ts';

const initialState = {};

export default (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case SET_PATIENT: {
      const newState = Object.assign({}, state);
      newState[action.patient.id] = action.patient.$clone();
      return newState;
    }

    case SET_PATIENTS: {
      const newState = Object.assign({}, state);

      action.patients.forEach((patient) => {
        newState[patient.id] = patient;
      });

      return newState;
    }

    case REMOVE_PATIENT: {
      const newState = Object.assign({}, state);

      delete newState[action.patientId];

      return newState;
    }

    case APPEND_PATIENTS: {
      const newState = Object.assign({}, state);

      action.patients.forEach((patient) => {
        newState[patient.id] = patient;
      });

      return newState;
    }

    case RESET_PATIENTS:
      return {};

    case START_SYNCING_PATIENT: {
      const newState = Object.assign({}, state);
      if (newState[action.patientId]) {
        newState[action.patientId].isSyncing = true;
      }
      return newState;
    }

    case STOP_SYNCING_PATIENT: {
      const newState = Object.assign({}, state);
      if (newState[action.patientId]) {
        newState[action.patientId].isSyncing = false;
      }
      return newState;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./main/reducers/patients-reducer.js